import { render, staticRenderFns } from "./CustomNotification.vue?vue&type=template&id=ca1a2460&scoped=true&"
import script from "./CustomNotification.vue?vue&type=script&lang=js&"
export * from "./CustomNotification.vue?vue&type=script&lang=js&"
import style0 from "./CustomNotification.vue?vue&type=style&index=0&id=ca1a2460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1a2460",
  null
  
)

export default component.exports